<div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
  <div class="row  row-for-levels" *ngIf="field">
    <div class="col-md-3 text-align-left">
      <label for="firstName" class="margin-bottom-0px margin-top-5px"> {{field.Title}}</label>
    </div>
    <div class="col-md-1 padding-left-0px padding-right-0px text-align-center">


      <input type="checkbox" class="width-18px background-2" [(ngModel)]="isChecked" [ngModelOptions]="{standalone: true}">
    </div>
    <div class="col-md-4" hidden>
      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="field.Remarks" maxlength="100"></textarea>
    </div>
  </div>

  <div class="row" *ngIf="isChecked && Data && Data.HasChildren">

    <auto-gen-children class="col-12" [Data]="Data" [field]="Data.Data" [mode]="mode"></auto-gen-children>

  </div>
  <!--<div class="row" *ngIf="!field.Value &&  Data  && Data.HasChildren">
    {{field.Title}} has no field value !!!
    <auto-gen-children class="col-12" [Data]="Data" [field]="Data.Data"></auto-gen-children>
    

  </div>-->

</div>
